(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[273],{

/***/ 73465:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspirations/[slug]",
      function () {
        return __webpack_require__(44853);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ PostsTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/richtext/dist/asText.js
var asText = __webpack_require__(98268);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  text-align: center;\n  transition: 0.3s;\n  min-height: 100%;\n  padding: 1rem;\n  &:hover {\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);\n    // background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  position: relative;\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  text-align: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  margin-top: 7px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n  margin-top: 7px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.colors.redLight;
}, function(props) {
    return props.theme.colors.white;
});
var Image = globalStyles/* styled.div */.zo.div(_templateObject1(), function(param) {
    var square = param.square;
    return square ? "100%" : undefined;
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject2(), function(param) {
    var align = param.align;
    return align;
});
var Title = globalStyles/* styled.h3 */.zo.h3(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.red;
});
var Text = globalStyles/* styled.p */.zo.p(_templateObject4(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
});
var Tags = globalStyles/* styled.p */.zo.p(_templateObject5(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/PostsTile.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 




var PostsTile = function(param) {
    var key = param.key, link = param.link, image = param.image, title = param.title, text = param.text, tags = param.tags, _align = param.align, align = _align === void 0 ? "center" : _align, _square = param.square, square = _square === void 0 ? true : _square;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        square: square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: image,
                            height: 320,
                            sizes: "(max-width: 540px) 66vw, (max-width: 1279px) 50vw, 20vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        align: align,
                        children: [
                            title && typeof title !== "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: asText/* asText */.S(title)
                            }),
                            title && typeof title === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: asText/* asText */.S(text)
                            }),
                            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                children: tags.join(", ")
                            })
                        ]
                    })
                ]
            })
        })
    }, key);
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/index.ts



/***/ }),

/***/ 36336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ VideoPlayer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react-player/youtube.js
var youtube = __webpack_require__(15655);
var youtube_default = /*#__PURE__*/__webpack_require__.n(youtube);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()));

;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/VideoPlayer.tsx




var VideoPlayer = function(param) {
    var image = param.image, video = param.video;
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Wrapper, {
        className: (0,clsx/* clsx */.W)("video", {
            landscaped: (image === null || image === void 0 ? void 0 : (ref = image.dimensions) === null || ref === void 0 ? void 0 : ref.width) >= (image === null || image === void 0 ? void 0 : (ref1 = image.dimensions) === null || ref1 === void 0 ? void 0 : ref1.height),
            portrait: (image === null || image === void 0 ? void 0 : (ref2 = image.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width) < (image === null || image === void 0 ? void 0 : (ref3 = image.dimensions) === null || ref3 === void 0 ? void 0 : ref3.height)
        }),
        children: video && /*#__PURE__*/ (0,jsx_runtime.jsx)((youtube_default()), {
            className: "react-player",
            url: video === null || video === void 0 ? void 0 : video.embed_url,
            width: "100%",
            height: "100%"
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/VideoPlayer/index.ts



/***/ }),

/***/ 15537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ PostsSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/@next/components/molecules/PostsTile/index.ts + 2 modules
var PostsTile = __webpack_require__(21437);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/organisms/PostsSlider/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 29%;\n      width: 50px;\n      height: 50px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none !important;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block !important;\n      top: 24vw;\n      width: 40px;\n      height: 40px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    position: absolute;\n    top: 30%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    border-radius: 50%;\n    width: 56px;\n    height: 56px;\n    color: transparent;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    z-index: 1;\n    transform: translate3d(0, 0, 0);\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: 20px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -14px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    left: 32px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -14px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    right: 32px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      overflow: visible;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-track {\n    display: flex !important;\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    height: auto;\n\n    & > div {\n      height: 100%;\n\n      & > div {\n        height: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0px -12px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0px -4px;\n      overflow: visible;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-list {\n    margin: 0px -20px;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: -60px;\n    padding: 98px 158px 75px;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    padding: 100px 64px 180px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: -40px;\n    padding: 70px 24px 143px;\n    overflow: hidden;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 180px 213px 125px;\n  background-color: ",
        ";\n  margin-bottom: -124px;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 38px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 21px;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: -0.5px;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 100%;\n  color: ",
        ";\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: -0.5px;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 100%;\n  color: ",
        ";\n  ",
        "\n\n  &:after {\n    content: '';\n    display: block;\n    height: 2px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  height: 100%;\n  padding: 0 1em;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}





var slickArrow = (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), chevron_left, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5()));
var slickNext = (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), chevron_right, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));
var slickTrack = (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()));
var slickSlide = (0,styled_components_browser_esm/* css */.iv)(_templateObject12());
var slickList = (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject13()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject15()));
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject20(), function(props) {
    return props.theme.colors.light;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject17()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject18()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject19()), slickList, slickTrack, slickSlide, slickArrow, slickPrev, slickNext);
var Header = globalStyles/* styled.div */.zo.div(_templateObject24(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject21()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject22()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject23()));
var Title = globalStyles/* styled.h2 */.zo.h2(_templateObject26(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject25()), utils/* pageTitle */.tj);
var Link = globalStyles/* styled.a */.zo.a(_templateObject28(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject27()), function(props) {
    return props.theme.colors.red;
});
var Slide = globalStyles/* styled.div */.zo.div(_templateObject29());

;// CONCATENATED MODULE: ./src/@next/components/organisms/PostsSlider/PostsSlider.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 











var PostsSlider = function(param) {
    var path = param.path, posts = param.posts;
    var sliderSettings = {
        arrows: true,
        autoplay: false,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: constants/* mediumScreen */.M7,
                settings: {
                    slidesToShow: 2,
                    swipeToSlide: true
                }
            },
            {
                breakpoint: constants/* smallScreen */.xC,
                settings: {
                    slidesToShow: 1,
                    swipeToSlide: true
                }
            }, 
        ],
        slidesToScroll: 1,
        slidesToShow: 3
    };
    var slider = (0,react.useRef)(null);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "posts-slider",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                className: "posts-slider__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        className: "posts-slider__header__title",
                        children: intl.formatMessage(src_intl/* commonMessages.youMayAlsoLike */.i4.youMayAlsoLike)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: path,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            className: "posts-slider__header__link",
                            children: intl.formatMessage(src_intl/* commonMessages.showMore */.i4.showMore)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                ref: slider,
                children: posts && posts.map(function(pagelink, i) {
                    var ref, ref1;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var item = pagelink;
                    if (!item) {
                        return null;
                    }
                    var tags = item === null || item === void 0 ? void 0 : (ref = item.tags) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                        var tag = param.tag;
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var _tag = tag;
                        return _tag.name;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsTile/* PostsTile */.m, {
                            link: (0,prismic_config/* linkResolver */.kG)(item),
                            image: item === null || item === void 0 ? void 0 : item.image,
                            title: item === null || item === void 0 ? void 0 : item.title,
                            tags: (item === null || item === void 0 ? void 0 : item.category) ? [
                                item === null || item === void 0 ? void 0 : item.category
                            ] : tags
                        }, item === null || item === void 0 ? void 0 : (ref1 = item._meta) === null || ref1 === void 0 ? void 0 : ref1.id)
                    });
                })
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/PostsSlider/index.ts



/***/ }),

/***/ 44853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/SliceZone.js + 1 modules
var SliceZone = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
;// CONCATENATED MODULE: ./src/@next/components/molecules/ImageMarker/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    box-shadow: 0 0 0 0 rgba(195, 76, 62, 1);\n  }\n  50% {\n    box-shadow: 0 0 0 30px rgba(195, 76, 62, 0.5);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    box-shadow: 0 0 0 0 rgba(195, 76, 62, 1);\n  }\n  50% {\n    box-shadow: 0 0 0 15px rgba(195, 76, 62, 0.5);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 20px;\n    height: 20px;\n    border: 4px solid #a52e20;\n    animation: ",
        " 3s cubic-bezier(0.19, 1, 0.22, 1) infinite both;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n  border: 6px solid #a52e20;\n  border-radius: 50%;\n\n  box-sizing: border-box;\n  cursor: pointer;\n\n  transform: translate(-50%, -50%);\n\n  animation: ",
        " 3s cubic-bezier(0.19, 1, 0.22, 1) infinite both;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n    box-shadow: ",
        ";\n    color: ",
        ";\n\n    .primitive-overlay {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      padding: ",
        ";\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  position: absolute;\n  min-width: 220px;\n  max-width: 350px;\n  width: 30%;\n  margin-top: -3%;\n\n  transform: translate(-50%, -100%);\n\n  z-index: 100;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    width: 0;\n    height: 0;\n    bottom: calc(-",
        " - 2px);\n    left: calc(50% - ",
        ");\n    transform: rotate(180deg);\n    border-left: ",
        " solid transparent;\n    border-right: ",
        " solid transparent;\n    border-bottom: ",
        " solid ",
        ";\n\n    &::after {\n      position: absolute;\n      content: ' ';\n      width: 0;\n      height: 0;\n      top: 3px;\n      left: calc(50% - ",
        ");\n      border-left: ",
        " solid transparent;\n      border-right: ",
        " solid transparent;\n      border-bottom: ",
        " solid\n        ",
        ";\n      clip-path: inset(0 0 2px);\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    padding: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var pulse2 = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject2());
var Image = globalStyles/* styled.img */.zo.img(_templateObject3());
var MarkerWrapper = globalStyles/* styled.div */.zo.div(_templateObject4());
var Marker = globalStyles/* styled.div */.zo.div(_templateObject6(), pulse, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject5(), pulse2));
var Overlay = globalStyles/* styled.div */.zo.div(_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), theme.popover.borderWidth, theme.popover.borderColor, theme.popover.borderRadius, theme.popover.backgroundColor, theme.popover.shadow, theme.colors.white, theme.typography.baseFontFamily, theme.typography.smallFontSize, theme.typography.baseLineHeight, theme.popover.padding);
});
var Arrow = globalStyles/* styled.span */.zo.span(_templateObject10(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.borderColor, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.backgroundColor);
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject12(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), theme.typography.baseFontFamily, theme.typography.smallFontSize, theme.typography.baseLineHeight, theme.popover.padding);
});
var Text = globalStyles/* styled.p */.zo.p(_templateObject13(), function(param) {
    var spacing = param.theme.spacing;
    return "1rem ".concat(spacing.gutter, " 1.8rem ").concat(spacing.gutter);
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/ImageMarker/ImageMarker.tsx










var getItemPosition = function(marker) {
    return {
        top: "".concat(marker.top),
        left: "".concat(marker.left)
    };
};
var ImageMarker = function(_param) {
    var image = _param.image, marker = (0,_object_without_properties/* default */.Z)(_param, [
        "image"
    ]);
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), visible = ref4[0], setVisible = ref4[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: (0,clsx/* clsx */.W)("image-marker", {
            landscaped: (image === null || image === void 0 ? void 0 : (ref = image.dimensions) === null || ref === void 0 ? void 0 : ref.width) >= (image === null || image === void 0 ? void 0 : (ref1 = image.dimensions) === null || ref1 === void 0 ? void 0 : ref1.height),
            portrait: (image === null || image === void 0 ? void 0 : (ref2 = image.dimensions) === null || ref2 === void 0 ? void 0 : ref2.width) < (image === null || image === void 0 ? void 0 : (ref3 = image.dimensions) === null || ref3 === void 0 ? void 0 : ref3.height)
        }),
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                field: image,
                width: 860,
                style: {
                    maxWidth: "auto",
                    height: "100%"
                },
                sizes: "(max-width: 1278px) 100vw, 33vw"
            }),
            marker.top && marker.left && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    (marker === null || marker === void 0 ? void 0 : marker.link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (0,prismic_config/* linkResolver */.kG)(marker.link),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                                style: getItemPosition(marker)
                            }, "marker")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker, {
                        style: getItemPosition(marker),
                        onMouseOver: function() {
                            return setVisible(!visible);
                        },
                        onMouseLeave: function() {
                            return setVisible(!visible);
                        }
                    }, "marker"),
                    visible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overlay, {
                        style: getItemPosition(marker),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                    field: marker.text
                                })
                            })
                        ]
                    }, "overlay")
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/ImageMarker/index.ts


// EXTERNAL MODULE: ./src/@next/components/molecules/VideoPlayer/index.ts + 2 modules
var VideoPlayer = __webpack_require__(36336);
// EXTERNAL MODULE: ./src/@next/components/organisms/PostsSlider/index.ts + 2 modules
var PostsSlider = __webpack_require__(15537);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/views/Project/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & strong {\n    font-weight: 600;\n  }\n  & em {\n    font-style: italic;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 0 160px;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 40px 0 96px;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 124px 0 200px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 18px;\n    padding-bottom: 18px;\n    flex-direction: column;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 10px;\n    padding-bottom: 10px;\n  "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: ",
        ";\n  line-height: 140%;\n  color: #2c2c2c;\n  padding-top: 34px;\n  padding-bottom: 34px;\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-column: 1;\n    "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: 100%;\n    margin-right: 0;\n    order: 1;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr;\n  "
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  column-gap: 20px;\n  row-gap: 20px;\n  width: 100%;\n  max-width: 75%;\n  grid-template-columns: 1fr 1fr;\n  // flex-shrink: 0;\n  margin-right: 40px; // project-img max-width of 66,66% - margin-right (86 / 2);\n\n  .landscaped {\n    grid-column: span 2;\n    ",
        "\n  }\n\n  ",
        "\n  ",
        "\n  picture {\n    display: inline-block;\n    width: 100%;\n  }\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 1;\n    max-width: 100%;\n    margin-top: 18px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 25%; // project-data max-width of 33,33% - margin-right of project-img (86 / 2);\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 10px;\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: #2c2c2c;\n  p {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    margin-bottom: 16px;\n    color: ",
        ";\n    ",
        "\n  }\n\n  a {\n    text-decoration: underline;\n    color: ",
        ";\n  }\n\n  b {\n    font-weight: 600;\n  }\n\n  strong {\n    color: ",
        ";\n  }\n\n  i {\n    font-style: italic;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 28px;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 18px;\n    margin-top: 28px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid rgba(#000000, 0.1);\n  padding-top: 38px;\n  margin-top: 30px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 2px;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 4px;\n  ",
        "\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n  &.align-end {\n    align-items: flex-end;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 160%;\n  color: #839098;\n  white-space: nowrap;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 160%;\n  color: #5b6870;\n  margin-left: 10px;\n  word-break: break-word;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 20px -5px -5px;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin: 28px -5px -5px;\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 36px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  height: 46px;\n  border: 2px solid rgba(44, 44, 44, 0.1);\n  box-sizing: border-box;\n  border-radius: 55px;\n  padding: 0 20px;\n  font-size: ",
        ";\n  line-height: 100%;\n  color: #2c2c2c;\n  margin: 5px;\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}


var styles_Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject());
var styles_Container = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(styles_templateObject1());
var Slices = globalStyles/* styled.div */.zo.div(styles_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject3()));
var Other = globalStyles/* styled.div */.zo.div(styles_templateObject5());
var Title = globalStyles/* styled.h1 */.zo.h1(styles_templateObject8(), function(props) {
    return props.theme.typography.h2FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject7()));
var Information = globalStyles/* styled.div */.zo.div(styles_templateObject10(), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject9()));
var Images = globalStyles/* styled.div */.zo.div(_templateObject14(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject11()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject12()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject13()));
var styles_Content = globalStyles/* styled.div */.zo.div(_templateObject16(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject15()));
var Description = globalStyles/* styled.div */.zo.div(_templateObject18(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject17()), function(props) {
    return props.theme.colors.blueLight;
}, function(props) {
    return props.theme.colors.red;
});
var Attributes = globalStyles/* styled.div */.zo.div(_templateObject21(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject19()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject20()));
var AttributeItem = globalStyles/* styled.div */.zo.div(_templateObject23(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject22()));
var AttributeName = globalStyles/* styled.div */.zo.div(_templateObject24(), function(props) {
    return props.theme.typography.smallFontSize;
});
var AttributeValue = globalStyles/* styled.div */.zo.div(_templateObject25(), function(props) {
    return props.theme.typography.smallFontSize;
});
var AttributeValueLink = (0,globalStyles/* styled */.zo)(AttributeValue)(_templateObject26());
var Tags = globalStyles/* styled.div */.zo.div(_templateObject28(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject27()));
var TagItem = globalStyles/* styled.div */.zo.div(_templateObject30(), function(props) {
    return props.theme.typography.smallFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject29()));

// EXTERNAL MODULE: ./src/@next/components/slices/SliceRelatedProducts/index.tsx + 2 modules
var SliceRelatedProducts = __webpack_require__(65395);
// EXTERNAL MODULE: ./src/@next/components/organisms/ProductList/styles.ts
var styles = __webpack_require__(12330);
// EXTERNAL MODULE: ./src/@next/components/molecules/ProductTile/styles.ts
var ProductTile_styles = __webpack_require__(49520);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLinkedProducts/styles.ts

function SliceLinkedProducts_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 30px 0 0;\n    "
    ]);
    SliceLinkedProducts_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 0 0;\n    "
    ]);
    SliceLinkedProducts_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-size: ",
        ";\n    font-family: ",
        ";\n    line-height: 1em;\n    font-weight: lighter;\n    color: ",
        ";\n    letter-spacing: -0.5px;\n    padding: 40px 0 0;\n    ",
        "\n    ",
        "\n    * {\n      font: inherit;\n    }\n  "
    ]);
    SliceLinkedProducts_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SliceLinkedProducts_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 60px;\n    padding-top: 60px;\n  "
    ]);
    SliceLinkedProducts_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 40px;\n    padding-top: 40px;\n  "
    ]);
    SliceLinkedProducts_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 80px;\n  padding-top: 80px;\n  ",
        "\n  ",
        "\n"
    ]);
    SliceLinkedProducts_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 20px;\n  "
    ]);
    SliceLinkedProducts_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 30px;\n  ",
        "\n  ",
        "\n"
    ]);
    SliceLinkedProducts_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    "
    ]);
    SliceLinkedProducts_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceLinkedProducts_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    ",
        "\n  }\n"
    ]);
    SliceLinkedProducts_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



// import { pageTitle } from '@styles/utils';
var pageTitle = (0,styled_components_browser_esm/* css */.iv)(SliceLinkedProducts_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SliceLinkedProducts_styles_templateObject2(), function(props) {
        return props.theme.typography.h2FontSize;
    }, function(props) {
        return props.theme.typography.thinFontFamily;
    }, theme.colors.baseFont, globalStyles/* media.largeScreen */.BC.largeScreen(SliceLinkedProducts_styles_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLinkedProducts_styles_templateObject1()));
});
var SliceLinkedProducts_styles_Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(SliceLinkedProducts_styles_templateObject6(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceLinkedProducts_styles_templateObject4()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLinkedProducts_styles_templateObject5()));
var styles_Title = globalStyles/* styled.div */.zo.div(SliceLinkedProducts_styles_templateObject8(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLinkedProducts_styles_templateObject7()), pageTitle);
var List = globalStyles/* styled.h2 */.zo.h2(SliceLinkedProducts_styles_templateObject10(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceLinkedProducts_styles_templateObject9()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLinkedProducts/SliceLinkedProducts.tsx








function SliceLinkedProducts(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliceLinkedProducts_styles_Wrapper, {
        className: "slice-item slice-linked-products",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: primary.slicetitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* List */.aV, {
                    loading: false,
                    children: fields.slice(0, 4).map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,prismic_config/* linkResolver */.kG)(item.productlink),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductTile_styles/* Wrapper */.im, {
                                    "data-cy": "product-tile",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile_styles/* Image */.Ee, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                                field: item.productimage,
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "100%"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductTile_styles/* Bottom */.z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile_styles/* Title */.Dx, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                        field: item.productname
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile_styles/* Price */.tA, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                        field: item.productprice
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile_styles/* Category */.WD, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                        field: item.productcategory
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            })
        ]
    });
}
SliceLinkedProducts.componentName = "linkedproducts";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceLinkedProducts/index.tsx


;// CONCATENATED MODULE: ./src/views/Project/Slices.ts


var components = {
    // accordion: SliceAccordion,
    // architectreviews: SliceArchitectReviews,
    // benefits: SliceBenefits,
    // benefitsprogram: SliceBenefitsProgram,
    // collections: SliceCollections,
    // color_sample: SliceColorSample,
    // consulttoolbox: SliceConsultToolbox,
    // content_photo_photo_50: SliceBlogContentPhotoPhoto,
    // content_photo_text_30_60: SliceBlogContentTextPhoto,
    // content_text_photo_60_30: SliceBlogContentTextPhoto,
    // content_text_text_50: SliceBlogContentTextText,
    // content_photo_text: SliceContentPhotoText,
    // content_photo_photo: SliceContentPhotoPhoto,
    // cta: SliceCta,
    // downloadfiles: SliceDownloadFiles,
    // excerpt: SliceExerpt,
    // htmlembded: SliceHtmlEmbded,
    // formembded: SliceFormEmbded,
    // franchisecontact: SliceFranchiseContact,
    // heroimg: SliceHeroImg,
    // iconbanner: SliceIconBanner,
    // iconcta: SliceIconCta,
    // imagecta: SliceImageCta,
    // inspiration: SliceInspiration,
    // instagram_posts: SliceInstagramPosts,
    // labeled_icons: SliceLabeledIcons,
    // linkbutton: SliceLinkButton,
    // mediaslider: SliceMediaSlider,
    // ourpartners: SliceOurPartners,
    // product_details: SliceProductDetails,
    // product_features: SliceProductFeatures,
    // quote: SliceQuote,
    // relatedpagesslider: SliceRelatedPagesSlider,
    relatedproducts: SliceRelatedProducts/* SliceRelatedProducts */.k,
    linkedproducts: SliceLinkedProducts
};

;// CONCATENATED MODULE: ./src/views/Project/Page.tsx












var Page = function(param) {
    var project = param.project, projects = param.projects, slices = param.slices;
    var ref;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        className: "realisation-project",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: project.title
                    }),
                    project && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Information, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
                                children: project.media.map(function(z, i) {
                                    return (z === null || z === void 0 ? void 0 : z.video) ? /*#__PURE__*/ (0,react.createElement)(VideoPlayer/* VideoPlayer */.Y, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, z), {
                                        key: "project-video-".concat(i)
                                    })) : /*#__PURE__*/ (0,react.createElement)(ImageMarker, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, z), {
                                        key: "project-image-marker-".concat(i)
                                    }));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                            field: project.description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Attributes, {
                                        children: [
                                            project.category && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Style:",
                                                            id: "Nul8w0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.category
                                                    })
                                                ]
                                            }),
                                            project.door_size && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Door size:",
                                                            id: "yKVXwz"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.door_size
                                                    })
                                                ]
                                            }),
                                            project.color && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Door color:",
                                                            id: "YC1Aw1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.color
                                                    })
                                                ]
                                            }),
                                            project.glass_type && (project.category || "").includes("Industrial") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Glass type:",
                                                            id: "/8eufO"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.glass_type
                                                    })
                                                ]
                                            }),
                                            project.handle_style && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Handle:",
                                                            id: "5QCYcD"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.handle_style
                                                    })
                                                ]
                                            }),
                                            project.handle_color && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Handle color:",
                                                            id: "HfNop+"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValue, {
                                                        children: project.handle_color
                                                    })
                                                ]
                                            }),
                                            project.interior_designer_link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Project:",
                                                            id: "402guk"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValueLink, {
                                                        as: "a",
                                                        href: project.interior_designer_link,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: project.interior_designer_view_name || project.interior_designer_link
                                                    })
                                                ]
                                            }),
                                            project.product_link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AttributeItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeName, {
                                                        children: intl.formatMessage({
                                                            defaultMessage: "Product:",
                                                            id: "jgPXwd"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeValueLink, {
                                                        as: "a",
                                                        href: project.product_link,
                                                        children: project.product_view_name || project.product_link
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    Boolean((ref = project.tag_list) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                        children: project.tag_list.map(function(z, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem, {
                                                children: z.name
                                            }, "project_tag_".concat(i));
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slices, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                    slices: slices,
                    components: components
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Other, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsSlider/* PostsSlider */.U, {
                    path: paths/* paths.inspirations */.H.inspirations,
                    posts: projects
                })
            })
        ]
    });
};
Page.displayName = "ProjectPage";
/* harmony default export */ var Project_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Project/View.tsx





var View = function(param) {
    var project = param.project, projects = param.projects, slices = param.slices, seo = param.seo, slug = param.params.slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Project_Page, {
                project: project,
                projects: projects,
                slices: slices
            })
        ]
    });
};
View.displayName = "ProjectView";
/* harmony default export */ var Project_View = (View);

;// CONCATENATED MODULE: ./src/views/Project/index.tsx


;// CONCATENATED MODULE: ./src/pages/inspirations/[slug].ts

var __N_SSG = true;
/* harmony default export */ var _slug_ = (Project_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3537,8940,7453,3955,9774,2888,179], function() { return __webpack_exec__(73465); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);